import React from 'react';
import { Container, Box, Avatar, Typography } from '@mui/material';

const Landing = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: '5%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Avatar 
          alt="Logo" 
          src="logo_old.png" 
          variant="rounded" 
          sx={{
              height: 450,
              width: 450,
            }} />
          <Typography variant="h2" gutterBottom>
            IRP Inspect Reply Pro
          </Typography>
      </Box>      
    </Container>
  );
};

export default Landing;